import { SectionTabsLayout, type SectionTabItem } from "./section-tabs-layout";

const USERS_ACCESS_TABS: SectionTabItem[] = [
  {
    label: "Users",
    to: "/users",
    match: (pathname) => pathname === "/users",
  },
  {
    label: "Admins",
    to: "/admins",
    match: (pathname) => pathname.startsWith("/admins"),
  },
  {
    // Advertiser provisioning sits under Users & Access rather than in its own
    // sidebar section: an advertiser IS a user account with a grant on it, and
    // the operator who provisions one is the same operator who bans, verifies
    // and comps accounts on the neighbouring tabs.
    label: "Advertisers",
    to: "/advertisers",
    match: (pathname) => pathname.startsWith("/advertisers"),
  },
  {
    label: "Audit Logs",
    to: "/audit",
    match: (pathname) => pathname.startsWith("/audit"),
  },
];

export function UsersAccessLayout() {
  return <SectionTabsLayout id="users-access" items={USERS_ACCESS_TABS} />;
}
